import React from 'react';
import { FormattedMessage } from 'react-intl';
import style from '../pages/Realisations.module.css';
import { renderLi, renderP, renderUl } from '../services/renderValues';
import Realisation from '../types/ProjectType';
import ButtonExternalLink from './UI/ButtonExternalLink';
import Title from './UI/Title';

/**
 * ## Shows a project in a card
 * Displays a list of technologies used, a description, a picture and links to download or to github
 *
 * @param {project} Realisation - The project to display
 * @returns {React.ReactNode}
 */
function Project({ project }: { project: Realisation }) {
  return (
    <div className={`${style.project} row`} data-testid="project">
      <div className="col-12 col-lg-4">
        <div className={style.projectImage}>
          <img src={project.image} alt={project.name} />
        </div>
      </div>
      <div className="col-12 col-lg-8">
        <div className={style.projectDescription}>
          <Title level={2} custom css="text-uppercase mb-0 ft-wt-600">
            {project.name}
          </Title>
          <h3>Description</h3>

          <article className="open-sans-font text-justify">
            <FormattedMessage
              id={project.description}
              values={
                {
                  p: renderP,
                  ul: renderUl,
                  li: renderLi,
                } as Record<string, any>
              }
            />
          </article>

          <br />
          <h3>Technologies</h3>
          <ul className={style.labelList} data-testid="technologies">
            {project.technologies.map((tech) => (
              <li key={tech} className={style.label}>
                {tech}
              </li>
            ))}
          </ul>
          <div className={`${style.buttons} pull-right`}>
            {project.downloadLink && (
              <ButtonExternalLink
                icon="btnDownload"
                link={project.downloadLink}
                id={`${project.name} download`}
                download
              >
                <FormattedMessage id="download" />
              </ButtonExternalLink>
            )}
            {project.githubLink.map((link) => (
              <ButtonExternalLink
                key={link}
                icon="btnGithub"
                link={link}
                id={link}
              >
                Github
              </ButtonExternalLink>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
export default Project;
